import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const SliderContainerViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
  margin-bottom: 20px;

    h1 {
      font-size: 20px;
      margin-bottom: 5%;
    }
  `,
  tablet: css`
    h1 {
      font-size: 46px;
      margin-bottom: 5%;
    }
  `,
  tabletLandscape: css`
    h1 {
      font-size: 46px;
      margin-bottom: 5%;
    }
  `,

  browser: css`
    h1 {
      margin-bottom: 10%;
    }
  `,
};

export const SliderContainer = styled.div`
  button {
    background-color: ${({ theme }) => theme.colors.nrmaBlue};
    color: white;
  }
  margin-bottom: 40px;

  .horizontal-slider {
    width: 100%;
    height: 50px;
  }

  .horizontal-slider .example-thumb {
    top: 5px;
    width: 40px;
    height: 40px;
    background-color: #000e82;
    border-radius: 40px;
  }
  .example-track.example-track-1 {
    background-color: #28f0b4;
  }
  .horizontal-slider .example-track {
    top: 20px;
    height: 12px;
    border-radius: 50px;
  }
  .example-thumb {
    font-size: 0.9em;
    text-align: center;
    background-color: black;
    color: white;
    cursor: pointer;
    border: 5px solid gray;
    box-sizing: border-box;
  }

  .example-track {
    position: relative;
    background-color: #000e82;
  }
  .labels {
    display: flex;
    justify-content: space-between;
  }
  .labels > p {
    font-size: 14px;
  }
  h1 {
    color: #000e82;
  }
  button {
    height: 48px;
    width: 111px;
    border: 0;
    float: right;
    cursor: pointer;
  }

  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return SliderContainerViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? SliderContainerViews["tabletLandscape"]
          : SliderContainerViews["tablet"];

      case "browser":
        return SliderContainerViews["browser"];
    }
  }}
`;
